import Chart from 'react-apexcharts';
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export default function AnalyticChart() {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  const placementTrackerAnalyticsTableGraph = useSelector(
    (state) => state.general.placementTrackerAnalyticsTableGraph.data,
  );
  const placementTrackerAnalyticsTableGraphLoading = useSelector(
    (state) => state.general.placementTrackerAnalyticsTableGraph.loading,
  );

  const getSeriesData = (key) => placementTrackerAnalyticsTableGraph?.map((e) => e?.[key]);

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 6,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: placementTrackerAnalyticsTableGraph?.map((e) => e?.course_batch_name),
    },
    yaxis: {
      labels: {
        formatter: (val) => Math.round(val),
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      markers: {
        shape: 'circle',
      },
    },
    colors: ['#2F80ED', '#27AE60', '#EB5757', '#cac848ff'], // Blue, Green, Red
    grid: {
      strokeDashArray: 4,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
  };

  const series = [
    {
      name: 'Internship',
      data: getSeriesData('totalInterns'),
    },
    {
      name: 'Placed',
      data: getSeriesData('totalPlaced'),
    },
    {
      name: 'Rejected',
      data: getSeriesData('totalRejected'),
    },
    {
      name: 'Pending',
      data: getSeriesData('totalWaitingForPlacement'),
    },
  ];

  return (
    <Box sx={{ p: 2 }} overflow={'auto'} width={'100%'}>
      {placementTrackerAnalyticsTableGraphLoading ? (
        <Skeleton height={350} width={isSm ? 500 : '100%'} />
      ) : (
        <Chart options={chartOptions} series={series} type="bar" height={350} width={isSm ? 500 : '100%'} />
      )}
    </Box>
  );
}
